import fr from './fr.json'

const i18n = {
  fr,
}

export default i18n
